import { FC, useEffect, useRef, useState } from "react"
import { DiaryRow } from "./types"
import { TableAttachmentsItem, TableAttachmentsWrapper } from "./styles"
import { useResize } from "app/lib/hooks/useResize"
import { useDebounceCallback } from "shared/lib/debounce/useDebounce"

type DiaryAttachmentsCellProps = {
  row: DiaryRow
}
type VisibleAttachment = {
  type: string;
  attachment: string | number;
}
export const DiaryAttachmentsCell: FC<DiaryAttachmentsCellProps> = ({
  row
}) => {
  const [ attachments, setAttachments ] = useState<string[]>([]);
  const [ visibleAattachments, setVisibleAattachments ] = useState<VisibleAttachment[]>([]);

  const { width } = useResize()

  const attachmentsWrapper = useRef<HTMLDivElement | null>(null);

  const calcVisibleAattachments = useDebounceCallback(() => {
    if (!attachmentsWrapper.current) return;

    const arr = [];
    const width = attachmentsWrapper.current.offsetWidth - 20;
    let innerWidth = 0;
    let plus = attachments.length;

    for (let index = 0; index < attachments.length; index++) {
      const attachment = attachments[index];

      innerWidth += 18;
      if (innerWidth <= width) {
        arr.push({
          type: 'img',
          attachment
        });
        plus--;
      } else {
        arr.push({
          type: 'span',
          attachment: plus
        });
        break;
      }
    }

    setVisibleAattachments(arr)
  }, 500)

  useEffect(() => {
    setAttachments(row.attachments?.map(el=>el.id) || []);
  }, [row])

  useEffect(() => {
    calcVisibleAattachments();
  }, [attachments, width])

  if (!attachments?.length) {
    return (
      <>-</>
    )
  }

  return (
    <TableAttachmentsWrapper ref={attachmentsWrapper}>
      {visibleAattachments.map((el, index)=> {
        const path = `/ecpp/attachments/files?attachmentId=${el.attachment as string}`
        return (
          <TableAttachmentsItem>
            {el.type === 'img' ? <img src={path} alt={`attachment_${index}`} /> : <span>+{el.attachment}</span>}
          </TableAttachmentsItem>
        )
      })}
    </TableAttachmentsWrapper>
  )
}